import { render, staticRenderFns } from "./MenberVipInner.vue?vue&type=template&id=499ec431&scoped=true"
import script from "./MenberVipInner.vue?vue&type=script&lang=js"
export * from "./MenberVipInner.vue?vue&type=script&lang=js"
import style0 from "./MenberVipInner.vue?vue&type=style&index=0&id=499ec431&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ec431",
  null
  
)

export default component.exports